module.exports = __webpack_public_path__ + "img/device_1006_2.91ad1963.svg";